<div libFlexRow [libFlexRowGap]="isMobileView() ? '8px' : '16px'">
  @for (item of items(); track item.title; let index = $index) {
    <div libFlexColumn>
      <div
        [attr.aria-hidden]="true"
        (keyup.enter)="handleItemClick(item)"
        class="w-compliance-item"
        [class.na]="item.result === 'n/a'"
        [class.completed]="item.result === 'completed'"
        [class.failed]="item.result === 'failed'"
        [class.active]="result() === item.result"
        (click)="handleItemClick(item)"
        >
        <div libFlexRow [libFlexRowGap]="'8px'">
          @if (item.iconType) {
            <div libFlexColumn>
              <lib-icon [type]="item.iconType"></lib-icon>
            </div>
          }
          @if (!isMobileView() || !item.iconType) {
            <div libFlexColumn class="text">
              {{ item.title }}
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
